import jwtEncode from "jwt-encode";

import { ROLE_2FA_AUTH_REQUIRED } from "../config/roles";
import {
  PERMISSION_GROUP_LIST_STANDARD,
  PERMISSION_STANDARD_GROUPS,
} from "../constants/permissionGroups";

import type { SliceState } from "../store/auth.slice";
import type { LoginApiResult } from "../store/utils";

export const testUserId = "23ff934c-70a5-46fe-9ba4-e257039d0a1e";
export const testPermissions = Object.keys(
  PERMISSION_STANDARD_GROUPS
) as PERMISSION_GROUP_LIST_STANDARD[];
export const testCustomerId = "eeeeeeee-0005-eeee-eeee-eeeeeeeeeeee";

export function createAuthResponse(expiresInSeconds = 100): LoginApiResult {
  return {
    token_type: "Bearer",
    access_token: jwtEncode(
      {
        roles: [],
        permissions: testPermissions,
        volt_employee: false,
        username: "merchant1-portal@volt.pl",
        client_id: null,
        customer_id: "eeeeeeee-0005-eeee-eeee-eeeeeeeeeeee",
        environment: "production",
        user_id: "23ff934c-70a5-46fe-9ba4-e257039d0a1e",
        id: "23ff934c-70a5-46fe-9ba4-e257039d0a1e",
      },
      "foobar"
    ),
    refresh_token: "fakerefreshtoken",
    expires_in: expiresInSeconds,
  } as LoginApiResult;
}

export function createAuthState(
  authResponse: LoginApiResult,
  with2FA?: boolean
): SliceState {
  const {
    access_token: accessToken,
    refresh_token: refreshToken,
    expires_in,
  } = authResponse;

  const tokenExpiryMs = expires_in * 1000;

  return {
    accessToken,
    refreshToken,
    userId: testUserId,
    username: "user@volt.pl",
    roles: with2FA ? ([ROLE_2FA_AUTH_REQUIRED] as const) : [],
    permissions: with2FA ? [] : testPermissions,
    voltEmployee: false,
    expirationTimestamp: Date.now() + tokenExpiryMs,
    tokenExpiryMs,
    customerId: testCustomerId,
    customer: null,
    email: "",
    error: null,
  };
}
